import React from 'react'

const Polygon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 0L16 8H0L8 0Z" fill="currentColor" />
    </svg>
  )
}

export default Polygon
